import {clientFIO, clientFirstName, clientLastName, clientMiddleName} from "./SystemEntity"
import {systemEntityValueByKeyword} from "./systemEntityValueByKeyword"

function entityKey(entity: any): string {
    return String(entity?.id || entity?.keyword || "")
}

function entityHasValue(entity: any): boolean {
    return (entity?.value ?? "").toString().trim().length > 0
}

function mergeEntitiesPreferFilled(primary: any[], secondary: any[]): any[] {
    const map = new Map<string, any>()
    for (const entity of [...(primary || []), ...(secondary || [])]) {
        const key = entityKey(entity)
        if (!key) {
            continue
        }
        const prev = map.get(key)
        if (!prev) {
            map.set(key, entity)
            continue
        }
        if (!entityHasValue(prev) && entityHasValue(entity)) {
            map.set(key, {...prev, ...entity})
        }
    }
    return Array.from(map.values())
}

/** Слоты доп. подписантов: договор + настройки «заполнить за клиента», непустое value побеждает. */
export function signerSlotsForBody(template: any): any[] {
    const fromContract = Array.isArray(template?.additional_signers) ? template.additional_signers : []
    const fromSettings = Array.isArray(template?.settings?.additional_signers)
        ? template.settings.additional_signers
        : []
    const count = Math.max(
        fromContract.length,
        fromSettings.length,
        Number(template?.settings?.additional_signers_count) || 0,
    )
    const slots: any[] = []
    for (let i = 0; i < count; i++) {
        const contractSlot = fromContract[i] || {}
        const settingsSlot = fromSettings[i] || {}
        slots.push({
            ...settingsSlot,
            ...contractSlot,
            title: contractSlot.title || settingsSlot.title || `Подписант ${i + 1}`,
            system_entities: mergeEntitiesPreferFilled(
                contractSlot.system_entities,
                settingsSlot.system_entities,
            ),
        })
    }
    return slots
}

export function getComputedClientFio(template: any): string {
    if (!template?.system_entities) {
        return ""
    }
    const last_name = (systemEntityValueByKeyword(template, clientLastName.keyword, clientLastName.id) || "").toString().trim()
    const first_name = (systemEntityValueByKeyword(template, clientFirstName.keyword, clientFirstName.id) || "").toString().trim()
    const middle_name = (systemEntityValueByKeyword(template, clientMiddleName.keyword, clientMiddleName.id) || "").toString().trim()
    const fio_value = (systemEntityValueByKeyword(template, clientFIO.keyword, clientFIO.id) || "").toString().trim()
    const fio_components = [last_name, first_name, middle_name].filter(Boolean)
    return fio_components.length > 0 ? fio_components.join(" ") : fio_value
}

export function withComputedSignerFio(entity: any, slotEntities: any[]): any {
    const isFio = entity?.id === clientFIO.id || entity?.keyword === clientFIO.keyword
    if (!isFio) {
        return entity
    }
    if ((entity?.value ?? "").toString().trim()) {
        return entity
    }
    const computed = getComputedClientFio({system_entities: slotEntities})
    if (!computed) {
        return entity
    }
    return {...entity, value: computed}
}
